<div class="content-wrap1" triggers="manual" #p2="ngbPopover" (mouseenter)="openAnnouncementDetails(p2, $event.currentTarget)" (mouseleave)="popoverHoverOut(p2)" [ngbPopover]="popContent" [popoverTitle]="popTitle" placement="bottom">
  <ngx-newsticker *ngIf="this.announcements.length > 0" class="scroll-up" [title]="announcementTitle" [interval]="5000" [events]="eventList" [showCounter]="false" ></ngx-newsticker>
</div>

<ng-template #popTitle><strong>Announcement Details</strong></ng-template>
<ng-template #popContent>
  <form id="announcementDetails" class="search-form" #announcementForm="ngForm">
    <mat-form-field class="fifth-width">
      <input matInput readonly title="Type" [value]="this.currentSelectedAnnouncement.announcementType.announcementTypeCde" autocomplete="off" >
      <mat-hint>Type</mat-hint>
    </mat-form-field>
    <mat-form-field class="full-width">
      <input matInput readonly title="Title" [value]="this.currentSelectedAnnouncement.announcementTitle" autocomplete="off" >
      <mat-hint>Title</mat-hint>
    </mat-form-field>
    <mat-form-field class="fifth-width">
      <input  id="announcementDate" matInput  name="announcementDate" [value]="this.convertDate(this.currentSelectedAnnouncement.effectiveDate)">
      <mat-datepicker-toggle matSuffix disabled></mat-datepicker-toggle>
      <mat-hint>Effective Date</mat-hint>
    </mat-form-field>
    <mat-form-field class="fifth-width">
      <input matInput readonly [value]="this.currentSelectedAnnouncement.releaseNumber" autocomplete="off" >
      <mat-hint>Release Number</mat-hint>
    </mat-form-field>
    <mat-form-field class="full-width">
      <textarea matInput cdkTextareaAutosize readonly class="full-width announcementText" [value]="this.currentSelectedAnnouncement.announcementTxt"></textarea>
      <mat-hint>Announcement Details</mat-hint>
    </mat-form-field>
    <mat-form-field class="quarter-width">
      <input matInput readonly [value]="this.currentSelectedAnnouncement.linkUrl" autocomplete="off" >
      <mat-hint>Link</mat-hint>
    </mat-form-field>
    <mat-form-field class="quarter-width">
      <input matInput readonly [value]="this.currentSelectedAnnouncement.linkTxt" autocomplete="off" >
      <mat-hint>Link Details</mat-hint>
    </mat-form-field>
  </form>
</ng-template>
